<ng-template #modalDocumento let-modal>
  <div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <ngx-spinner
      [fullScreen]="false"
      name="document-modal-viewer"
    ></ngx-spinner>
    <!-- teste -->
    <div class="d-flex justify-content-center" *ngIf="is_image">
      <img
        [src]="sanitize('data:image/jpg;base64, ' + document_source)"
        *ngIf="document_source"
      />
    </div>
    <custom-pdf-viewer
      *ngIf="type == 'application/pdf' && document_source"
      [pdfSrc]="document_source"
    ></custom-pdf-viewer>
    <app-form-alert [err_msg]="err_msg"></app-form-alert>
  </div>
  <div class="modal-footer">
    <a
      class="btn btn-blue material-button"
      [ngClass]="{ disabled: generating_blob || !documento.link }"
      [href]="documento.link"
      [download]="documento.filename"
      *ngIf="documento && !documento.click"
    >
      <span
        *ngIf="generating_blob"
        class="spinner-border spinner-border-sm my-1 mr-2"
        role="status"
        aria-hidden="true"
      ></span>
      <i class="fa fa-download"></i> Download
    </a>
    <button
      class="btn btn-blue material-button"
      (click)="documento.click()"
      *ngIf="documento && documento.click"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button
      type="button"
      class="btn btn-blue material-button"
      (click)="modal.close('Close click')"
    >
      Fechar
    </button>
  </div>
</ng-template>
